module.exports = __webpack_public_path__ + "img/shanghai02.ff42acea.png";